import AppLayout from "../AppLayout";
import { RowDataProvider } from "../contexts/RowDataContext";
import DeepLinkInitializer from "../pages/LandingPage/components/deep-link/DeepLinkInitializer";
import DeepLinkSetupTab from "../pages/LandingPage/components/deep-link/DeepLinkSetupTab";
import LandingPage from "../pages/LandingPage/LandingPage";
import SetupRenderer from "../pages/LandingPage/components/setup/SetupRenderer";

const PaymentsDeepLinkRoute = (): JSX.Element => {
  return (
    <RowDataProvider>
      <AppLayout showNavigation={false}>
        <DeepLinkInitializer>
          <SetupRenderer>
            <LandingPage navigationTabs={<DeepLinkSetupTab />} />
          </SetupRenderer>
        </DeepLinkInitializer>
      </AppLayout>
    </RowDataProvider>
  );
};

export default PaymentsDeepLinkRoute;
